import {
  BrowserRouter,
  Routes,
  Route,
  Link
} from "react-router-dom";
import "./index.css";

import PageHome from './pages/PageHome.js'
import PageFeature from './pages/PageFeature.js'
import PageAbout from './pages/PageAbout.js'


import './App.css';


function App() {
  // var prevScrollpos = window.pageYOffset;
  // window.onscroll = function () {
  //   var currentScrollPos = window.pageYOffset;
  //   if (prevScrollpos > currentScrollPos) {
  //     console.log('test');
  //     // document.getElementById("navbar").style.top = "0";
  //   } else {
  //     console.log('sss');
  //     // document.getElementById("navbar").style.top = "-50px";
  //   }
  //   prevScrollpos = currentScrollPos;
  // }



  return (
    <BrowserRouter>

      <nav className="navbar navbar-dark navbar-expand-lg bg-primary">
        <div className="container">
          <Link className="navbar-brand" style={{ color: 'white' }} to='/' ><b>KASIR BAGUS</b></Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <div className='me-auto'></div>
            <ul className="navbar-nav  mb-2 mb-lg-0" style={{ columnGap: '30px' }}>
              <li className="nav-item">
                <a className="nav-link" aria-current="page" href="#" style={{ color: 'white' }}>Produk</a>
              </li>
              <li className="nav-item">
                <Link className="nav-link" style={{ color: 'white' }} to='fitur' >Fitur</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" style={{ color: 'white' }} to='about' >Tentang Kami</Link>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#" style={{ color: 'white' }}>Kontak</a>
              </li>
              <li className="nav-item">
                <button className='btn btn-outline-light'>Coba Sekarang Gratis</button>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <Routes>
        <Route path="/" element={<PageHome />} />
        <Route path="/fitur" element={<PageFeature />} />
        <Route path="/about" element={<PageAbout />} />
      </Routes>

      <div className='p-5 bg-primary text-light' style={{ minHeight: '100px' }}>
        <div className='container d-flex' style={{ columnGap: '50px' }}>
          <div>
            <h4 style={{ fontWeight: 'bold', width: '190px' }}>KASIRKU BAGUS</h4>
          </div>
          <div>
            <p className='mb-1'><b>Kontak</b></p>
            <p className='mb-1'>gandatadyosurya@gmail.com</p>
            <p className='mb-1'>+62 82264576766</p>
          </div>
          <div>
            <p className='mb-1'><b>Alamat</b></p>
            <p className='mb-1'>Gang Kamboja No 6<br />Kecamatan Balas Klumprik<br />Kota Surabaya</p>
          </div>
          <div>
            <p className='mb-1'><b>Customer Service</b></p>
            <p className='mb-1'>gandatadyosurya@gmail.com</p>
            <p className='mb-1'>+62 82264576766</p>
          </div>
        </div>
      </div>

    </BrowserRouter>
  );
}

export default App;
